import { PartnerInput as PartnerInputComponent } from './PartnerInput.component'
import { connector } from './PartnerInput.connector';

export const PartnerInput = connector(PartnerInputComponent);
